import { jsPDF } from "jspdf"
import html2Canvas from "html2canvas"
// import msjh from "@/assets/fonts/msjh-normal.js"

function cropCanvas(sourceCanvas, left, top, width, height) {
  let destCanvas = document.createElement("canvas")
  destCanvas.width = width
  destCanvas.height = height
  let destCavasCxt = destCanvas.getContext("2d")
  destCavasCxt.beginPath()
  destCavasCxt.rect(0, 0, width, height)
  destCavasCxt.fillStyle = "white"
  destCavasCxt.fill()
  destCavasCxt.drawImage(
    sourceCanvas,
    left,
    top,
    width,
    height, // source rect with content to crop
    0,
    0,
    width,
    height
  ) // newCanvas, same size as source rect
  return destCanvas
}

function download(htmlId, fileName, callback) {
  html2Canvas(document.querySelector(htmlId), {
    allowTaint: true,
    useCORS: true,
    scale: 2
  }).then(
    function(canvas) {
      let contentWidth = canvas.width
      let contentHeight = canvas.height

      let pageHeight = (contentWidth / 592.28) * 841.89
      let leftHeight = contentHeight
      let position = 0
      let imgWidth = 552.28
      let imgHeight = (552.28 / contentWidth) * contentHeight
      let pageData = canvas.toDataURL("image/jpeg", 1.0)
      let PDF = new jsPDF("", "pt", "a4")

      let contentNormalHeight = (canvas.width * 801.89) / 552.28

      if (leftHeight < pageHeight) {
        PDF.addImage(pageData, "JPEG", 20, 20, imgWidth, imgHeight)
      } else {
        while (leftHeight > 0) {
          var childCanvas = cropCanvas(canvas, 0, position, contentWidth, contentNormalHeight)
          var childCtx = childCanvas.getContext("2d")
          childCtx.fillStyle = "white"
          var childPageData = childCanvas.toDataURL("image/jpeg", 1.0)
          PDF.addImage(childPageData, "JPEG", 20, 20, imgWidth, 801.89)
          leftHeight -= pageHeight - 40
          position += contentNormalHeight
          if (leftHeight > 0) {
            PDF.addPage()
          }
        }
      }
      PDF.save(fileName + ".pdf")
      callback()
    }.bind(this)
  )
}

export { download }
